import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { limpiarAreaConfiguracion, obtenerAreaConfiguracion, editarAreaConfiguracion } from '../../../actions/configuracion';

const EditarArea = ({ area, reestablecerArea }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.areas);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [areaData, setAreaData] = useState({
        id: null,
        nombre: null
    });

    /* Editar area */
    const handleInputChange = ({ target }) => {
        setAreaData({
            ...areaData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(areaData.nombre){
            await setStatusProcesar(true);
            await dispatch(editarAreaConfiguracion(areaData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setAreaData({
                id: null,
                nombre: null
            });
            setEditarModal(false);
            reestablecerArea(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarAreaConfiguracion());
    }, []);

    useEffect(() => {
        if(area){
            setEditarModal(true);
            
            dispatch(obtenerAreaConfiguracion(area?.id));

            setAreaData({
                ...areaData,
                id: area?.id
            });
        }
    }, [area]);

    useEffect(() => {
        if(detalles){
            setAreaData({
                ...areaData,
                id: detalles?.id, 
                nombre: detalles?.nombre
            });
        }
    }, [detalles]);

    return (
        <Modal show={editarModal} backdrop="static" size="md" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar área</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={areaData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarArea;